import BllinkUtils from "./utils/utils";
import {Currency} from "./currency";
import Money from "./utils/money";

export function CurrencyValue({ children, currency, notInCents = false }) {
    let amount = '';
    if  (isNaN(children)) {
        amount = children;
    } else {
        if (notInCents) {
            amount = BllinkUtils.Strings.numberWithCommas(Money.roundNumber(Number(children), 2));
        } else {
            amount = BllinkUtils.Strings.numberWithCommas(Money.roundNumber(Number(children) / 100, 2));
        }
    }
    return (
        <span className="currency-value">
            <span className="currency-value-amount">{amount}</span>
            <Currency>{currency}</Currency>
        </span>
    );
}
